export default {
  setRequests(state, requests) {
    state.requests = requests
  },
  setLoadingRequests(state, loading) {
    state.loadingRequests = loading
  },
  setLoadingFiles(state, loading) {
    state.loadingFiles = loading
  },
  setRequestsPageInfo(state, pageInfo) {
    state.requestsPageInfo = pageInfo
  },
  setRequest(state, request) {
    state.request = request
  },
  setRequestProvider(state, provider) {
    state.request.provider = provider
  },
  setUploads(state, uploads) {
    state.uploads = uploads
  },
  setPatient(state, patient) {
    state.patient = patient
  },
  setProvider(state, provider) {
    state.provider = provider
  },
  setFiles(state, files) {
    state.files = files
  },
  setFile(state, file) {
    state.file = file
  },
  setRecordTypes(state, types) {
    state.recordTypes = types
  },
  setPatientSearchResults(state, searchResults) {
    state.patientSearchResults = searchResults
  },
  setProviderSearchResults(state, searchResults) {
    state.providerSearchResults = searchResults
  },
  setUserSearchResults(state, searchResults) {
    state.userSearchResults = searchResults
  },
  setTotalItems(state, totalItems) {
    state.totalItems = totalItems
  },
  setPagination(state, pagination) {
    state.pagination = pagination
  },
  setGroups(state, groups) {
    state.groups = groups
  },
  setGroupsPageInfo(state, pageInfo) {
    state.groupsPageInfo = pageInfo
  },
  setRequestProviderOverrides(state, overrides) {
    state.requestProviderOverrides = overrides
  },
  setPatientRequest(state, requests) {
    state.patientRequests = requests
  },
  setDocumentProvider(state, provider) {
    state.setDocumentProvider = provider
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/mutations.js